import type { ReactElement } from "react";
export default function IndexPage(): ReactElement {
    return (
        <div
            style={{
                textAlign: "center",
                fontSize: "2rem",
                height: "100vh",
            }}
        >
            Please wait...
        </div>
    );
}
